import type { UserType } from './dataLayer.types';

type BaseEvent = {
  event: string;
  user_type?: UserType;
  user_id?: string | number;
  [key: string]: unknown;
};

const firedKeys = new Set<string>();

export function pushDataLayerEvent(payload: BaseEvent, uniqueKey?: string): void {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];

  if (uniqueKey) {
    if (firedKeys.has(uniqueKey)) return;
    firedKeys.add(uniqueKey);
  }

  window.dataLayer.push(payload);

  if (import.meta.env.DEV) {
    console.log('[dataLayer]', payload);
  }
}
